import { render, staticRenderFns } from "./AddEmailTemplate.vue?vue&type=template&id=41b36d9f&scoped=true&"
import script from "./AddEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./AddEmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddEmailTemplate.vue?vue&type=style&index=0&id=41b36d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b36d9f",
  null
  
)

export default component.exports